export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  category: string;
  tags: string[];
  views: string;
}

export const articles: Article[] = [
  {
    id: 1,
    title: "2026年最值得期待的十部国产大片",
    slug: "2026-top-10-chinese-movies",
    excerpt: "新的一年，国产电影市场精彩纷呈。我们为你精选了十部即将上映的国产大片，涵盖科幻、动作、喜剧等多种类型，总有一部适合你。",
    content: `<p>2026年，中国电影市场迎来了前所未有的繁荣。从科幻巨制到温情喜剧，从动作大片到文艺佳作，国产电影的品质和多样性都在不断提升。以下是我们精心挑选的十部最值得期待的国产大片：</p>
<h3>1. 《流浪地球3》</h3>
<p>作为中国科幻电影的标杆之作，《流浪地球》系列的第三部将带领观众进入更加宏大的宇宙冒险。郭帆导演再次执掌导筒，特效全面升级，剧情更加扣人心弦。</p>
<h3>2. 《满江红2》</h3>
<p>张艺谋导演继前作取得巨大成功后，再度回归古装悬疑题材。全新的故事，全新的阵容，但依然保持了前作的紧张氛围和精妙布局。</p>
<h3>3. 《封神第三部》</h3>
<p>乌尔善导演的封神系列迎来终章。宏大的神话世界观、精湛的特效制作，将为这个史诗三部曲画上完美的句号。</p>
<h3>4. 《喜剧之王3》</h3>
<p>周星驰经典IP的全新演绎，新一代喜剧演员接棒，在欢笑中传递温暖与感动。</p>
<p>此外还有《哪吒3》、《长安三万里2》、《深海2》等优秀作品值得期待。2026年的中国电影，精彩不容错过！</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20Chinese%20film%20elements%2C%20dramatic%20lighting%2C%20movie%20posters%20arrangement%2C%20cinema%20atmosphere%2C%20warm%20and%20cool%20tone%20contrast%2C%20entertainment%20industry%20aesthetic&width=1200&height=600&seq=article-cover-01&orientation=landscape",
    author: "影评人小王",
    publishDate: "2026-07-30",
    category: "dianying",
    tags: ["电影推荐", "国产大片", "2026", "观影指南"],
    views: "12.5万",
  },
  {
    id: 2,
    title: "《狂飙》第二季剧情深度解析",
    slug: "kuangbiao-season2-analysis",
    excerpt: "《狂飙》第二季强势回归，剧情更加扑朔迷离。本文将从人物关系、剧情走向、主题深度等多个角度，为你全面解析这部现象级剧集。",
    content: `<p>《狂飙》第二季延续了第一季的高水准制作，在扫黑除恶的主题下，进一步深化了人物塑造和剧情层次。以下是对本季剧情的深度解析：</p>
<h3>人物关系更加复杂</h3>
<p>安欣在新一季中面对更加狡猾的对手。高启强的残余势力以新的面目出现，而隐藏在体制内部的"保护伞"也更加隐蔽。人物之间的正邪界限变得模糊，每个人都有自己的立场和苦衷。</p>
<h3>剧情走向出乎意料</h3>
<p>第二季的剧情不再局限于江城，而是将视野扩展到了更广阔的地域。跨国犯罪、金融诈骗、网络黑产等新型犯罪形式成为新的焦点。</p>
<h3>社会意义的深化</h3>
<p>在紧张刺激的剧情之外，该剧还深入探讨了法治建设、社会治理、人性善恶等深层次话题，使得作品具有更强的现实意义。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Crime%20drama%20analysis%20scene%20with%20detective%20investigation%20elements%2C%20mysterious%20dark%20cityscape%2C%20suspenseful%20mood%2C%20professional%20cinematography%2C%20film%20noir%20aesthetic&width=1200&height=600&seq=article-cover-02&orientation=landscape",
    author: "剧评人老张",
    publishDate: "2026-07-28",
    category: "dianshiju",
    tags: ["狂飙", "剧评", "国产剧", "深度解析"],
    views: "8.9万",
  },
  {
    id: 3,
    title: "动漫推荐：2026夏季新番必看清单",
    slug: "anime-2026-summer-must-watch",
    excerpt: "2026年夏季新番已经全面开播，众多优秀作品让人眼花缭乱。我们为你整理了本季最值得追的十部动漫，帮你做出选择。",
    content: `<p>2026年夏季新番季如约而至，本季作品类型丰富，质量上乘。无论你是热血少年漫的忠实粉丝，还是偏爱轻松日常的观众，都能在本季找到心仪的作品：</p>
<h3>热血战斗类</h3>
<p>《鬼灭之刃 无限城篇》无疑是本季最受瞩目的作品。剧场版级别的制作质量，加上原作漫画最精彩的篇章，让每一帧都值得反复观看。</p>
<h3>日常治愈类</h3>
<p>《摇曳露营 第四季》继续用温暖的画风和治愈的故事，为观众带来心灵的慰藉。在快节奏的生活中，这样一部慢节奏的作品显得尤为珍贵。</p>
<h3>科幻悬疑类</h3>
<p>《命运石之门 重启》以全新的视角重新演绎经典故事，新老粉丝都能从中获得不同的观感体验。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20collage%20with%20various%20anime%20characters%20in%20dynamic%20poses%2C%20colorful%20vibrant%20illustrations%2C%20Japanese%20anime%20art%20style%2C%20summer%20vibe%2C%20exciting%20atmosphere&width=1200&height=600&seq=article-cover-03&orientation=landscape",
    author: "动漫达人阿杰",
    publishDate: "2026-07-25",
    category: "dongman",
    tags: ["动漫推荐", "新番", "2026", "追番指南"],
    views: "6.7万",
  },
  {
    id: 4,
    title: "NBA总决赛回顾：传奇与荣耀",
    slug: "nba-finals-2026-review",
    excerpt: "2026年NBA总决赛落下帷幕，七场鏖战堪称经典。让我们一起回顾这场篮球盛宴中的精彩瞬间和关键转折。",
    content: `<p>2026年NBA总决赛以一场史诗级的第七战落下帷幕。两支顶级球队为全世界球迷奉献了一场篮球盛宴：</p>
<h3>系列赛回顾</h3>
<p>从第一场比赛开始，双方就展现出了极高的竞技水平。你来我往的比分交替，让每一场比赛都充满悬念。特别是第四场的三加时大战，堪称NBA总决赛历史上的经典之战。</p>
<h3>关键球员表现</h3>
<p>两队的当家球星在总决赛舞台上展现了超凡的个人能力。无论是关键时刻的绝杀，还是防守端的全力拼抢，都让人看到了真正的冠军之心。</p>
<h3>历史意义</h3>
<p>这届总决赛不仅是一场体育盛事，更创造了多项NBA历史纪录，注定将被载入篮球史册。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Basketball%20championship%20celebration%20moment%20with%20trophy%20and%20confetti%2C%20dramatic%20arena%20lighting%2C%20sports%20victory%20atmosphere%2C%20professional%20sports%20photography&width=1200&height=600&seq=article-cover-04&orientation=landscape",
    author: "体育记者李华",
    publishDate: "2026-07-22",
    category: "tiyu",
    tags: ["NBA", "总决赛", "篮球", "赛事回顾"],
    views: "15.3万",
  },
  {
    id: 5,
    title: "如何选择适合自己的在线视频平台",
    slug: "how-to-choose-video-platform",
    excerpt: "面对众多在线视频平台，如何选择最适合自己的那一个？本文从内容质量、播放体验、会员价格等多个维度为您分析。",
    content: `<p>随着在线视频行业的快速发展，用户面对的选择也越来越多。如何从众多平台中找到最适合自己的那一个，成为了一个值得思考的问题：</p>
<h3>内容为王</h3>
<p>选择视频平台，首要考虑的是内容。不同平台有不同的内容侧重，有的擅长自制剧，有的在纪录片领域独树一帜，有的则在动漫资源上更加丰富。</p>
<h3>播放体验至关重要</h3>
<p>高清画质、流畅播放、无广告干扰，这些看似基础的要求，在不同平台上的表现却差异很大。51视频在这些方面做到了行业领先水平。</p>
<h3>性价比考量</h3>
<p>会员价格、家庭共享、多端支持等都是需要考虑的因素。51视频提供的高质量免费内容，让用户无需付费就能享受优质的观影体验。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20TV%20screen%20showing%20streaming%20interface%2C%20cozy%20home%20theater%20setup%2C%20warm%20ambient%20lighting%2C%20entertainment%20lifestyle&width=1200&height=600&seq=article-cover-05&orientation=landscape",
    author: "科技编辑小陈",
    publishDate: "2026-07-18",
    category: "zongyi",
    tags: ["视频平台", "选择指南", "在线观看", "观影体验"],
    views: "5.2万",
  },
  {
    id: 6,
    title: "纪录片推荐：不可错过的十部自然纪录片",
    slug: "top-10-nature-documentaries",
    excerpt: "自然纪录片以其震撼的画面和深刻的内涵，吸引了无数观众。我们精选了十部不容错过的经典自然纪录片。",
    content: `<p>从深邃的海洋到广袤的草原，从极地冰原到热带雨林，自然纪录片用镜头记录了这个星球上最壮丽的风景和最动人的生命故事：</p>
<h3>1. 《地球脉动》系列</h3>
<p>BBC的这部纪录片系列堪称自然纪录片的巅峰之作。从第一季到第三季，每一帧画面都美得令人窒息。</p>
<h3>2. 《蓝色星球》系列</h3>
<p>深入海洋世界，揭示那些人类极少涉足的神秘领域。深海生物的奇异与美丽，让人叹为观止。</p>
<h3>3. 《舌尖上的中国》系列</h3>
<p>虽然是一部美食纪录片，但它所展现的中国自然风光和人文风情，丝毫不逊色于任何自然纪录片。</p>
<p>这些纪录片在51视频平台均可免费在线观看，高清不卡顿，为你带来极致的视觉享受。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Breathtaking%20nature%20landscape%20with%20mountains%20and%20wildlife%2C%20golden%20sunset%20light%2C%20documentary%20cinematography%20style%2C%20epic%20scale%2C%20National%20Geographic%20aesthetic&width=1200&height=600&seq=article-cover-06&orientation=landscape",
    author: "自然爱好者",
    publishDate: "2026-07-15",
    category: "jilupian",
    tags: ["纪录片", "自然", "推荐", "BBC"],
    views: "7.8万",
  },
];

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(category: string): Article[] {
  return articles.filter((a) => a.category === category);
}

export function getLatestArticles(limit: number = 5): Article[] {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, limit);
}